import CacheCollection from 'collection/CacheCollection'
import {DqResponse} from 'generated/JavaTOmodifications'
import _ from 'lodash'
import {fetchDqAPI} from 'module/Dq/api/DqApi'
import {serverErrorHandler} from 'module/ConfirmDialog/component/ConfirmDialogContainer'


const cache = new CacheCollection<Promise<any> | any>();
const dqSearchableMap: { [dqkey in string]?: boolean } = {}

export function isDqSearchable(dqkey: string): boolean {
	return dqSearchableMap[dqkey] !== false
}

export function parseDqResponse(response: DqResponse | any[], dataId: string, dataText: string) {
	if (response && response.hasOwnProperty('count') && response.hasOwnProperty('elements')) {
		const r = response as DqResponse
		dqSearchableMap[r.id] = r.searchable
		return r.elements
	}
	let elements = response as any[]
	let data = _.map(elements, (object) => {
		let text;
		if (_.isArray(dataText)) {
			text = _.map(dataText, function (text) {
				return object[text]
			}).join(" ")
		} else {
			text = object[dataText]
		}
		let val = object[dataId]
		return {
			value: val,
			label: text,
		}
	})
	return data;
}

interface SearchDqParams {
	dqkey: string
	params?: { [key in string]: string | number }
	filter?: string
	url?: string
	dataId?: string
	dataText?: string
	isAze?: boolean
}

export function searchDq({
	dqkey,
	params,
	filter,
	url,
	dataId = 'value',
	dataText = 'label',
	isAze = false,
}: SearchDqParams): Promise<DqResponse['elements']> {
	if (!filter || !isDqSearchable(dqkey)) filter = ''
	let requestId = [dqkey, params && JSON.stringify(params, Object.keys(params).sort()), url || '', filter].join('|')
	let cached = cache.getCache(requestId)
	if (cached) {
		return cached
	} else {
		const req = fetchDqAPI({dqkey, params, url, filter, isAze}).then(function (response) {
			cache.setCache(requestId, req, response.data?.cacheTTL)
			return parseDqResponse(response.data, dataId, dataText)
		})
		cache.setCache(requestId, req)
		req.catch((err) => {
			cache.removeCache(requestId)
			void serverErrorHandler(err)
		})
		return req;
	}
}